import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { EntityPage } from '@/shared/models/entity-page';

import { IBill } from '../model/bill';
import { namespace as billsNamespace } from '../namespace';

interface TState {
  upcomingBill: IBill | null;
  bills: EntityPage<IBill>;
}

const initialState: TState = {
  upcomingBill: null,
  bills: {
    items: [],
    total: 0,
    limit: 10,
    offset: 0,
  },
};

const billsSlice = createSlice({
  name: billsNamespace,
  initialState,
  reducers: {
    setBills: (state, action: PayloadAction<EntityPage<IBill>>) => {
      state.bills = action.payload;
    },
    setUpcomingBill: (state, action: PayloadAction<IBill>) => {
      state.upcomingBill = action.payload;
    },
  },
});

export { billsSlice, billsNamespace };
